import type { Entities } from '@inwink/entities/entities';
import { expressionBuilder, ExpressionBuilderBase } from '@inwink/expressions/expressionbuilder';
import { IInWinkAdminEntityV3DataSource, IDataSourceV3Options } from './datasource';

export function userPreferences(userPreferenceDatasource: IInWinkAdminEntityV3DataSource<any>,
    entityName: string, options?: IDataSourceV3Options) {
    return (ds) => {
        const datasource = ds;

        datasource.getViews = (viewEntityName?: string) => {
            const andPredicates: ((e: ExpressionBuilderBase) => ExpressionBuilderBase)[] = [
                (k) => k.WithString("entityname").Equals(viewEntityName ?? entityName)
            ];

            options?.viewFilters?.forEach((viewFilter) => {
                andPredicates.push(viewFilter);
            });

            return userPreferenceDatasource.query({
                filters: expressionBuilder((e) => e.And(andPredicates))
            }).then((res) => {
                return res.data;
            });
        };
        datasource.setView = (_view: Entities.IEntityView) => {
            const view = _view;
            // En V2 on stockait les filtres dans 'entityViewContent' en v3 dans 'content'
            if (view.entityViewContent && !view.content) {
                view.content = view.entityViewContent;
            }
            return userPreferenceDatasource.create(view);
        };
        datasource.updateView = (view: Entities.IEntityView) => {
            return userPreferenceDatasource.update(view);
        };
        datasource.deleteView = (entityviewid) => {
            return userPreferenceDatasource.delete([entityviewid]);
        };
    };
}
